// Mở đầu (STORY Phụ lục A): lớp phủ toàn màn kiểu vỏ số 5 (`--z-rite`), không khung, không dialog
// giữa màn. Mỗi bước một câu; chạm để tiếp, giữ 720ms ở cảnh chạm đèn / dẫn khí, chọn một dòng ở A6.
import type { JSX } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { t } from '@i18n/t';
import { advanceOpening, openingStep } from '@state/modules/story';
import { HoldButton } from '../kit/HoldButton';
import { TextButton } from '../kit/TextButton';

export function OpeningHost(): JSX.Element | null {
  const step = openingStep.value;
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    if (step) ref.current?.focus();
  }, [step?.id]);
  if (!step) return null;
  const speaker = step.speaker === 'servant' || step.speaker === 'steward' || step.speaker === 'lampSpirit';
  const tap = step.input.kind === 'tap';
  return (
    <section
      ref={ref}
      class={`ht-rite opening sp-${step.speaker}`}
      role="dialog"
      aria-modal="true"
      aria-label={t(`story.opening.${step.id}`)}
      data-id="opening"
      data-step={step.id}
      tabIndex={-1}
      onClick={tap ? () => advanceOpening() : undefined}
      onKeyDown={(e) => {
        if (tap && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          advanceOpening();
        }
      }}
    >
      <div class="rite-body" key={step.id}>
        {speaker && <b class="rite-speaker">{t(`story.speaker.${step.speaker}`)}</b>}
        <p class="rite-line" data-id="opening-line">
          {t(`story.opening.${step.id}`)}
        </p>
        {step.input.kind === 'hold' && (
          <HoldButton id="opening-hold" hint={t(step.input.labelKey)} onHold={() => advanceOpening()}>
            {t(step.input.labelKey)}
          </HoldButton>
        )}
        {step.input.kind === 'choice' && (
          <div class="rite-choices">
            {step.input.options.map((o) => (
              <TextButton
                key={o.value}
                id={`opening-choice-${o.value}`}
                onClick={() => advanceOpening(o.value)}
              >
                {t(o.key)}
              </TextButton>
            ))}
          </div>
        )}
      </div>
      {tap && <small class="rite-tap">{t('ui.opening.tap')}</small>}
    </section>
  );
}
